module.exports = __webpack_public_path__ + "img/fish_octopus.b798873d.png";